import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {sum} from 'lodash';
import accounting from 'javascripts/vendor/accounting';
import styled from "styled-components";

const ColorIcon = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${p => p.color};
  border-radius: 50%;
`;

const ChartTable = (props) => {
  const {
    labels,
    datasets,
    colors,
    swapRowsColumns,
    horizontalColors,
    horizontalTotal,
    verticalColors,
    verticalTotal,
    useCurrency,
  } = props;

  let swapDataSets = [];
  if (swapRowsColumns) {
    labels.forEach((label, index) => {
      let newDataSet = {label: label, values: []}
      datasets.forEach((dataset, index2) => {
        newDataSet.values.push(dataset.values[index])
      })
      swapDataSets.push(newDataSet)
    })
  }

  const rows = swapRowsColumns ? swapDataSets : datasets;
  const columns = swapRowsColumns ? datasets.map(dataset => dataset.label) : labels;

  let verticalTotals = [];
  if (verticalTotal) {
    verticalTotals = Array(columns.length).fill(0)

    columns.forEach((label, index) => {
      rows.forEach(row => {
        verticalTotals[index] += row.values[index]
      })
    })

    if (horizontalTotal) {
      let total = 0;
      rows.forEach(row => {
        total += sum(row.values)
      })
      verticalTotals.push(total);
    }
  }

  const prefix = useCurrency ? '$' : '';

  return (
    <div style={{overflow: 'auto'}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            {
              columns.map((column, index) =>
                <TableCell key={column} className="no_wrap" align='right'>
                  <div className="color_label">
                    {
                      horizontalColors ?
                      <ColorIcon color={colors[index]} /> : <span/>
                    }
                    {column}
                  </div>
                </TableCell>
              )
            }
            {
              horizontalTotal &&
              <TableCell align='right'>Total</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell className="no_wrap">
                  <div className="row_color_label">
                    {
                      verticalColors &&
                      <ColorIcon color={colors[index]} />
                    }
                    {row.label}
                  </div>
                </TableCell>
                {
                  row.values.map((value, index) =>
                    <TableCell key={index} align='right'>
                      { accounting.formatMoney(value, prefix, 2) }
                    </TableCell>
                  )
                }
                {
                  horizontalTotal &&
                  <TableCell align='right'>
                    { accounting.formatMoney(sum(row.values), prefix, 2) }
                  </TableCell>
                }
              </TableRow>
            ))
          }
          {
            verticalTotal &&
            <TableRow>
                <TableCell>Total</TableCell>
                {verticalTotals.map((total, index) =>
                  <TableCell key={index} align='right'>
                    { accounting.formatMoney(total, prefix, 2) }
                  </TableCell>
                )}
            </TableRow>
          }
        </TableBody>
      </Table>
    </div>
  );
}

export default ChartTable
